/** @module csi/card/UserCardRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Ref",
	"csi/widget/UserIcon",
	"csi/xml"
], function(declare,Ref,UserIcon,xml) {
	
	return declare(Ref, {
		/**
		 * @override
		 * Add any dependency paths required by renderer class
		 */
		addRendererDependencyPaths: function(h, paths) {
			paths.push(xml.path(h.m_id, "Image"));
		},

		/**
		 * @override
		 * Render image for user before link
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			const user = this._getReferencedNode(ctx, h);
			
			if (user) {
				new UserIcon({
					allowTooltip: false,
					cache: ctx.cache,
					userUrl: user.$URL
				}).placeAt(refNode);
			}
			
			return this.inherited(arguments);
		}
	});
});